export default "__VITE_ASSET__CTg5MPvL__"